export default __webpack_public_path__ + "15.668c77.svg";